import "./App.css";
import ThemeProvider from "./theme/ThemeProvider";
import { useRoutes } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import router from "./router";
import { SnackBarAlertProvider } from "./contexts/SnackbarContext";
import { SosSocketProvider } from "./contexts/SosSocketContext";
import { Suspense, useEffect } from "react";
import { getLocalStorageData } from "./shared/utils/localStorage";
import { Box, CircularProgress } from "@mui/material";

function App() {
  const content = useRoutes(router());

  useEffect(() => {
    const updateTitle = () => {
      const userData = getLocalStorageData("userData");
      document.title =
        userData?.userType === "SuperAdmin"
          ? "Smart Router (SuperAdmin)"
          : "Smart Router (Admin)";
    };

    updateTitle();
    window.addEventListener("userDataUpdated", updateTitle);
    window.addEventListener("storage", updateTitle);

    return () => {
      window.removeEventListener("userDataUpdated", updateTitle);
      window.removeEventListener("storage", updateTitle);
    };
  }, []);

  return (
    <ThemeProvider>
      <SnackBarAlertProvider>
        <SosSocketProvider>
          <CssBaseline />
          <Suspense
            fallback={
              <Box
                role="status"
                aria-label="Loading page"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "50vh",
                }}
              >
                <CircularProgress size={28} />
              </Box>
            }
          >
            {content}
          </Suspense>
        </SosSocketProvider>
      </SnackBarAlertProvider>
    </ThemeProvider>
  );
}

export default App;